// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React from "react";

import { conversationTypes } from "src/constants/display";
import WorkflowName from "src/containers/workflow/Name";
import { getWorkflowNextSeqNo } from "src/reducers";
import type { AppState, ConversationChecklistSettings } from "src/types";

import { AddButton } from "../styles";
import { AddButtonText } from "./styles";
type Props = {
  settings: ConversationChecklistSettings,
  isActive?: boolean,
  handleDropdown: Function,
  disabled: boolean,
  isMandatory: ?boolean,
  disabledMessage?: string,
};

const AddConversation = ({
  settings,
  isActive = false,
  handleDropdown,
  disabled,
  isMandatory,
  disabledMessage,
}: Props) => {
  const type = settings.type || "group";
  const { workflow } = settings;
  if (type === "workflow" && workflow) {
    return (
      <AddButton
        data-cy="add-conversation-button"
        type="button"
        isActive={isActive}
        onClick={handleDropdown}
        disabled={disabled}
        isMandatory={isMandatory}
      >
        <AddButtonText>
          {!disabledMessage && <>&#43; {i18n.t(k.ADD1)} </>}
          {disabledMessage ? disabledMessage : <WorkflowName id={workflow} />}
        </AddButtonText>
      </AddButton>
    );
  }

  return (
    <AddButton
      type="button"
      onClick={handleDropdown}
      disabled={disabled}
      isMandatory={isMandatory}
      data-cy="add-conversation-button"
    >
      <AddButtonText>
        &#43; {i18n.t(k.ADD1)} {conversationTypes[type][0]}
      </AddButtonText>
    </AddButton>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  seqNo: getWorkflowNextSeqNo(app),
});

export default connect(mapStateToProps)(AddConversation);
